import React from 'react';
import { useParams, Navigate, Outlet } from 'react-router-dom';
import { ProcessoUsuarioProvider } from './context/ProcessoUsuarioContext';

const ProcessoWrapper: React.FC = () => {
  const { processoId } = useParams<{ processoId: string }>();

  if (!processoId) {
    // Redirect to a "not found" or an appropriate page if processoId is not defined
    return <Navigate to="/acesso-negado" />;
  }

  return (
    <ProcessoUsuarioProvider processoId={processoId}>
      <Outlet />
    </ProcessoUsuarioProvider>
  );
};

export default ProcessoWrapper;
